import { render, staticRenderFns } from "./FontItalicIcon.vue?vue&type=template&id=32beeb6a&"
import script from "./FontItalicIcon.vue?vue&type=script&lang=js&"
export * from "./FontItalicIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports